import BlockRelatedArticlesComponent from './relatedArticles'

export default BlockRelatedArticlesComponent
